import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService } from '../../modules/profile/profile.service';

export const authGuard: CanActivateFn = () => {
  const authSrv = inject(ProfileService);
  const router = inject(Router);

  if (authSrv.isLoggedIn()) {
    return true;
  } else {
    void router.navigate(['/login']);
    return false;
  }
};
